import { DatePipe } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Component, ViewChild } from "@angular/core";
import { CalendarOptions, FullCalendarComponent } from "@fullcalendar/angular";
import { AttendanceService } from "../attendance.service";
import { AttendanceConstant } from "../attendance.constant";
import { CommonService } from "src/app/common.service";
import { Subscription } from "rxjs";
import { AppService } from "src/app/app.service";

import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction'; // a plugin

declare var $: any;
declare var moment: any;
@Component({
    selector: 'app-my-attendance',
    templateUrl: './my-attendance.component.html',
    styleUrls: ['./my-attendance.component.css']
})

export class MyAttendnaceComponent{
    constructor(private attendanceService: AttendanceService,
            private datePipe: DatePipe,
            private appService: AppService,
            private commonService: CommonService){
                window['myAttendanceCompRef'] = {comp: this}
    }

    private _myVar = moment();
    isListView: boolean = true;
    calendarOptions: CalendarOptions 
    = { 
        plugins: [dayGridPlugin, interactionPlugin],
        initialDate: moment().startOf('month').toDate().getTime(),
        initialView: 'dayGridMonth',
        // dateClick: this.handleDateClick.bind(this),
        eventContent : function(arg){
            let italicEl = document.createElement('i');
            italicEl.innerHTML = arg.event.extendedProps.title1;
            let arrayOfDomNodes = [ italicEl ]
            return { domNodes: arrayOfDomNodes }
        }
    };

    myAttendanceList: any[] = [];
    currentMonth: any = new Date();
    selectedMonthTimestamp: any = moment().toDate().getTime()/1000 | 0;
    isLoader: boolean = false;
    markAttendanceSubscription: Subscription;
    attendanceTypeSubscription: Subscription;
    attendanceTypeMap: any = {};

    @ViewChild('fullCalender',{ static: true}) calenderComponent: FullCalendarComponent;

    async ngOnInit(){
        // console.log("init")
        // this.attendanceTypeSubscription = this.attendanceService.attendanceTypeSubject.subscribe((data)=>{
        //     if(data){
        //         console.log("map")
        //         this.attendanceTypeMap = data.map;
        //     }
        // })

        // let data = await this.appService.getAttendnaceTypeObject().catch(()=>{});
        // if(data){
        //     this.attendanceTypeMap = data.map;
        // }

        this.markAttendanceSubscription = this.attendanceService.markAttendanceSubject.subscribe((data)=>{
            
            if(data){
                this._myVar = moment();
                this.getMyAttendance();
            }
        })
    }

    ngAfterContentInit(){
        $(".content").mCustomScrollbar();
    }

    ngOnDestroy(){
        if(this.markAttendanceSubscription){
            this.markAttendanceSubscription.unsubscribe();
        }
        if(this.attendanceTypeSubscription){
            this.attendanceTypeSubscription.unsubscribe();
        }
    }

    get myVar(): string {
        return this._myVar;
    }
    set myVar(value: string) {
        if (value !== this._myVar) {
            this._myVar = value;
            let strArr = this._myVar.split("-");
            let date = new Date(parseInt(strArr[0]), parseInt(strArr[1])-1);
            let time = date.getTime()/1000 |0;
            let time1 = date.getTime();
            this.navigateFullCalender(moment(time1).startOf('month').toDate().getTime());
          
            this.getMyAttendance(time);
        }
    }

    navigateFullCalender(time){
        this.calenderComponent.getApi().gotoDate(time);
    }

  
    async getMyAttendance(timestamp?){
        if(Object.keys(this.attendanceTypeMap).length <= 0){
             let data = await this.appService.getAttendnaceTypeObject().catch(()=>{});
            if(data){
                this.attendanceTypeMap = data.map;
            }
        }
        this.isLoader = true;
        this.attendanceService.getAttendance(timestamp)
            .subscribe((res: HttpResponse<any>)=>{
                this.isLoader = false;
                // console.log(res.body);
                this.myAttendanceList = res.body.attendances;
                this.preProcessAttendance(this.myAttendanceList);
                this.updateCalenderEvents();
                  this.enableTooltip();
            }, (error)=>{
                this.isLoader = false;
            })
    }

    preProcessAttendance(data){
        for(let attendance of this.myAttendanceList){
            attendance = this.attendanceService.preProcessAttendnaceData(attendance, this.attendanceTypeMap);
        }
    }

    timeOut: any;
    monthChange($event){
        if(this.timeOut){
            clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(()=>{
            this.getMyAttendance();
        }, 100)
    }



    changeView(){
        $(".calenderToggle").find('.material-icons-outlined').html('event_available');
        $('.myAttendance').toggleClass('caldViewCont');            

       if ($('.myAttendance').hasClass('caldViewCont')) {
          $('.calenderToggle').find('.material-icons-outlined').html('table_chart');
        //    return false;
       }

        this.isListView =  ! this.isListView;
        this.updateCalenderEvents();
    }

    updateCalenderEvents(){
        if(!this.isListView){
            let events = this.prepareCalenderEvents();
            this.calendarOptions.events = events;
        }
       
    }


    prepareCalenderEvents(){
        let events = [];
        for(let attendance of this.myAttendanceList){
            let obj = {};
            let title1 = "<div>";
            if(attendance.attendanceStr){
                title1 += "<span>" +attendance.attendanceStr;
            }
            if(attendance.statusStr){
                title1 += "<br> <span class='"+attendance.statusClass+"'>" +attendance.statusStr+ "</span>";
            }
            if(attendance.inTimestmap && attendance.outTimestamp){
                let timeStr = "<br><span class='fc-custom-date'>" + this.datePipe.transform(attendance.inTimestmap * 1000, 'hh:mm a') + " - "
                    +this.datePipe.transform(attendance.outTimestamp * 1000, 'hh:mm a') + "</span>";
                
                // let timeStr = "<br><span class='fc-custom-date'>09:45 AM - 06:55 PM</span>";
                title1 += timeStr;
            }
            title1 += "</div>";

            // //Attendnace
            let title = "";
            let startTime = "";
            if(attendance.attendanceStr){
                title = attendance.attendanceStr;
            }
            obj['title'] = title;
            if(attendance.timeForSort){
                startTime = this.datePipe.transform(attendance.timeForSort * 1000, 'yyyy-MM-dd');
            }
            obj['start'] = startTime;

            let  extendedProps = {};
            extendedProps['title1'] = title1;
            extendedProps['title'] = title;
            
            obj['extendedProps'] = extendedProps;
           
            events.push(obj);
          
        }

        return events;
    }

   
    
    handleDateClick(arg) {
        alert('date click! ' + JSON.stringify(arg))
    }

    onBlurMethod(attendance, val){
        // console.log(attendance.id, val)
        if(attendance.id && val && val.trim().length>=3){
            let data = {};
            data['id'] = attendance.id;
            data['remark'] = val;
            this.attendanceService.saveAttendanceRemark(data)
                .subscribe((res: HttpResponse<any>)=>{
                    // console.log(res.body);
                }, (error)=>{
                    
                })
        }
    }

    hideTooltip() {
        $('.tip1').each(function () {
            $(this).tooltip('hide');
        });
    }

    enableTooltip() {
        this.hideTooltip();
        setTimeout(function () {
            //   $(".content").mCustomScrollbar("update");
            $('.tip1').each(function () {
                $(this).tooltip(
                    {
                        html: true,
                        trigger: "hover",
                        title: $('#' + $(this).attr('data-tip')).html(),
                        customClass: 'tooltip-custom'
                    });
            });

            // $('.tip1').on('click', function () {
            //     $(this).tooltip('hide');
            // });
        }, 2000)
    }

}